import { render, staticRenderFns } from "./AdminChangePassword.vue?vue&type=template&id=0563c2ff&scoped=true&"
import script from "./AdminChangePassword.vue?vue&type=script&lang=js&"
export * from "./AdminChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./AdminChangePassword.vue?vue&type=style&index=0&id=0563c2ff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0563c2ff",
  null
  
)

export default component.exports